import { useIntl } from 'react-intl';

import {
	ProductGrid,
	useProductData,
	ProductCategory,
	ProductItem,
	categories,
} from '../product-subnav';

import { MobileNavTitle } from './mobile-nav-card';

export const MobileNavProductBusinessTeams = () => {
	const intl = useIntl();
	const { productsByTag } = useProductData();
	const businessTeamsProducts = productsByTag[ProductCategory.BusinessTeams] || [];

	return (
		<div>
			<MobileNavTitle title={intl.formatMessage(categories[ProductCategory.BusinessTeams].title)} />
			<ProductGrid>
				{businessTeamsProducts.map((product) => (
					<ProductItem key={product.id} {...product} />
				))}
			</ProductGrid>
		</div>
	);
};
